import React from 'react'
import { EditResaleAuthorizationWrapper } from '../../components/oldResaleAuth'
import { ResellerAuthorizationCreation } from '../../components/AddEditResellerAuthorization'
import {
  useCurrentCloudProvider,
  useGetAllUsers,
  useUserType,
} from '@labrav/common'
import { useFlag } from '@labrav/flags'
import PartnerProductsWrapper from '../PartnerProductsWrapper'
import ResaleAuthorizationsWrapper from '../ResaleAuthorizationsWrapper'

type WrapperChildProps = {
  externalBaseURL?: string
  search?: string
  crmOpportunityId?: string
  crmObjectLink?: string
}

const HubspotResellerAuthorizationCreationAzure = (
  props: Omit<
    React.ComponentProps<typeof ResellerAuthorizationCreation>,
    'users'
  >
) => {
  const partnerType = useUserType()
  const { users } = useGetAllUsers(partnerType)
  return <ResellerAuthorizationCreation {...props} users={users} />
}

const ExternalNewResaleAuthorizationInner = ({
  externalBaseURL,
  search,
  crmOpportunityId,
  crmObjectLink,
}: WrapperChildProps) => {
  const {
    flag: isMicrosoftResaleAuthorizationsEnabled,
    loading: microsoftResellerAuthorizationFlagLoading,
  } = useFlag('microsoftResellerAuthorization')
  const { flag: hubspotAzureResellerAuthFlag } = useFlag(
    'hubspotAzureResellerAuth'
  )
  const cloudMarketplace = useCurrentCloudProvider({
    microsoftResellerAuthorization:
      isMicrosoftResaleAuthorizationsEnabled?.value,
  })
  const isHubspotAzureResellerAuthEnabled =
    !!hubspotAzureResellerAuthFlag?.value

  if (microsoftResellerAuthorizationFlagLoading) {
    return <div data-testid="resale-authorizations-loader" />
  }

  if (
    isMicrosoftResaleAuthorizationsEnabled?.value &&
    isHubspotAzureResellerAuthEnabled &&
    cloudMarketplace === 'AZURE'
  ) {
    return (
      <HubspotResellerAuthorizationCreationAzure
        crmOpportunityId={crmOpportunityId}
        externalBaseURL={externalBaseURL}
        search={search}
      />
    )
  }

  return (
    <div>
      <EditResaleAuthorizationWrapper
        externalBaseURL={externalBaseURL}
        crmOpportunityId={crmOpportunityId}
        search={search}
        crmObjectLink={crmObjectLink}
      />
    </div>
  )
}

export const ExternalNewResaleAuthorization = () => (
  <PartnerProductsWrapper>
    <ResaleAuthorizationsWrapper>
      {(props: WrapperChildProps) => (
        <ExternalNewResaleAuthorizationInner {...props} />
      )}
    </ResaleAuthorizationsWrapper>
  </PartnerProductsWrapper>
)
